export const PreferenceState = {
  INIT: 'init',
  SUBMIT: 'submit',
  FIRST_DISMISS: 'first-dismiss',
  SECOND_DISMISS: 'second-dismiss',
  THIRD_DISMISS: 'third-dismiss',
  STOP_SHOWN: 'stop-shown',
} as const;
